import {FC, useCallback, useEffect, useState} from 'react';
import styled from 'styled-components';

import {UnthemedButton} from '@shared_web/components/core/button';
import {SvgIcon} from '@shared_web/components/core/svg_icon';
import {Flex} from '@shared_web/components/core2/flex';
import {icon_arrow_left_line} from '@shared_web/components/icons/icon_arrow_left_line';

import {translate} from '@mavismart_frontend/components/translate';
import {SearchResultContextProvider} from '@mavismart_frontend/contexts/search_result_context';
import {
  AdvancedSearchForm,
  AdvancedSearchResultsData,
} from '@mavismart_frontend/pages/tabs/advanced_search_form';
import {AdvancedSearchResults} from '@mavismart_frontend/pages/tabs/advanced_search_results';
import {getUserLanguage, useAccount} from '@mavismart_frontend/stores/account_store';

export const MobileSearch: FC = () => {
  const account = useAccount();
  const lang = getUserLanguage(account);

  const [isViewingResults, setIsViewingResults] = useState(false);
  const [searchResults, setSearchResults] = useState<AdvancedSearchResultsData | undefined>(
    undefined
  );

  // Everytime the data changes, we "navigate" to the results page
  useEffect(() => {
    setIsViewingResults(searchResults !== undefined);
  }, [searchResults]);

  const handleBackToSearchClick = useCallback(() => {
    setIsViewingResults(false);
  }, []);

  return (
    <SearchResultContextProvider value={searchResults}>
      <StyledAdvancedSearchForm
        $hidden={isViewingResults}
        expandedOnMount={false}
        onResults={setSearchResults}
      />
      <StyledSearchResults $hidden={!isViewingResults} key="results-list-with-back-button" $column>
        <UnthemedBackButton onClick={handleBackToSearchClick} expand>
          <Flex $width="100%" $gap="l" $padding="m" $align="center">
            <SvgIcon icon={icon_arrow_left_line} size={16} />
            {translate('back_to_search', lang).toLocaleUpperCase()}
          </Flex>
        </UnthemedBackButton>
        <TableWrapperHack>
          <AdvancedSearchResults />
        </TableWrapperHack>
      </StyledSearchResults>
    </SearchResultContextProvider>
  );
};

MobileSearch.displayName = 'MobileSearch';

const UnthemedBackButton = styled(UnthemedButton)`
  background-color: transparent;
  margin: -10px 0px 0 -10px;
  width: calc(100% + 20px);
  color: ${props => props.theme.main?.textColor};
`;

const StyledSearchResults = styled(Flex)<{$hidden: boolean}>`
  ${p => p.$hidden && 'display: none;'}
`;

const StyledAdvancedSearchForm = styled(AdvancedSearchForm)<{$hidden: boolean}>`
  ${p => p.$hidden && 'display: none;'}
`;

// Emulate the TableWrapper margin hack for mobile (backward compatibility)
const TableWrapperHack = styled.div`
  margin-left: -10px;
  width: calc(100% + 20px);
`;
